export const paymentColors = {
  primary: '#1976d2',
  success: '#4caf50',
  warning: '#ff9800',
  error: '#f44336',
  surface: '#fafafa',
  card: '#ffffff',
};

export const paymentSpacing = {
  sectionGap: 32,
  cardPadding: 24,
  wizardPadding: 16,
  stepGap: 8,
};

export const paymentTypography = {
  stepTitle: 'h6',
  sectionTitle: 'subtitle1',
  amount: 'h4',
  label: 'body2',
};

export const paymentWizard = {
  stepperHeight: 64,
  contentMaxWidth: 600,
  mobileContentMaxWidth: '100%',
};

export const paymentBreakpoints = {
  mobile: 375,
  tablet: 768,
  desktop: 1024,
};

export const paymentThemeExtension = {
  payment: {
    colors: paymentColors,
    spacing: paymentSpacing,
    typography: paymentTypography,
    wizard: paymentWizard,
    breakpoints: paymentBreakpoints,
  },
};

export function createPaymentTheme(baseTheme) {
  return {
    ...baseTheme,
    ...paymentThemeExtension,
  };
}
